/* lazy-plugins.js · v1 · Oct 9 2026 (live Oct 10)
   Owl Carousel loads only when a page actually builds an Owl carousel.
   Calls made before the library arrives are queued and replayed in order. */
(function ($) {
  if (!$ || !window.__lazyLibs) return;
  function lazy(name, url) {
    if (!url || $.fn[name]) return;
    var queue = [], state = 0;
    function stub() {
      if (!this.length) return this;
      queue.push([this, arguments]);
      if (state === 0) {
        state = 1;
        var s = document.createElement('script');
        s.src = url;
        s.onload = function () {
          var real = $.fn[name];
          if (real === stub) return;
          var q = queue; queue = [];
          for (var i = 0; i < q.length; i++) {
            try { real.apply(q[i][0], q[i][1]); } catch (e) { if (window.console) console.error(e); }
          }
        };
        document.head.appendChild(s);
      }
      return this;
    }
    $.fn[name] = stub;
  }
  lazy('owlCarousel', window.__lazyLibs.owl);
})(window.jQuery);
